/**
 * We need to map the v2 user with their counterpart on v1.
 * Therefore on every login we want to ensure the user is mapped
 */

import { useSupabaseClient } from '~/composables/useSupabaseClient';
import { useUserMapMutation } from '~/queries/useUserMapMutation';
import { checkIfAalStepUpRequiredAsync } from '~/utils/checkIfAalStepUpRequiredAsync';

export default defineNuxtPlugin({
	name: 'user-api-mapping',
	dependsOn: ['vue-query'],
	setup: () => {
		const supabase = useSupabaseClient();
		const { mapUser } = useUserMapMutation();

		supabase.auth.onAuthStateChange(async (event, s) => {
			if (event !== 'INITIAL_SESSION' || !s) {
				return;
			}

			const isAalStepUpRequired = await checkIfAalStepUpRequiredAsync(supabase).unwrapOr(true);

			if (isAalStepUpRequired) {
				return;
			}

			await mapUser.resultAsync();
		});
	},
});
